import Text from 'components/shared/Text'
import Link from 'components/shared/Link'
import { FormattedMessage } from 'react-intl'
import { FailedPageWrapper } from './styles'
import { CONTACT_LINK, HOME_LINK } from 'constants/links'

const FailedPage = () => (
    <FailedPageWrapper
        pt={[36, 64]}
        isFullWidth
        direction="column"
        align={['flex-start', 'center']}
    >
        <Text variant="heading1" color="grayscale_900">
            <FormattedMessage
                id="global.failed_page.heading"
                defaultMessage="Ups! Coś poszło nie tak – już się tym zajmujemy"
            />
        </Text>
        <Text
            variant="bodyLarge"
            color="grayscale_700"
            mt={[24, 16]}
            mb={[32, 40]}
            align={['left', 'center']}
        >
            <FormattedMessage
                id="global.failed_page.body_text"
                defaultMessage="Sprawdź status swojej płatności – informacje wysłaliśmy na adres e-mail podany w zamówieniu."
            />
        </Text>

        <Link
            path={HOME_LINK}
            variant="secondary"
            icon="arrow"
            iconColor="primary_500"
            data-testid="page-payment-failed-redirect-homepage"
        >
            <FormattedMessage
                id="global.btn.back_to_homepage"
                defaultMessage="Wróć do strony głównej"
            />
        </Link>
        <Text
            variant="heading3"
            color="grayscale_900"
            mt={[64, 112]}
            mb={[32, 40]}
        >
            <FormattedMessage
                id="global.failed_page.contact_text"
                defaultMessage="Jeśli masz pytania, skontaktuj się z nami:"
            />
        </Text>

        <Link
            path={CONTACT_LINK}
            variant="secondary"
            icon="arrow"
            iconColor="primary_500"
            data-testid="page-payment-failed-redirect-contact"
        >
            <FormattedMessage
                id="global.btn.contact_us"
                defaultMessage="Skontaktuj się z nami"
            />
        </Link>
    </FailedPageWrapper>
)

export default FailedPage
